import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const deleteFundingRequest = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "fundingRequests/deleteFundingRequest",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.delete(id);
  },
);

export const resetDeleteFundingRequest = createAction("fundingRequests/resetDeleteFundingRequest");
